import PageLoader from "@/components/building-blocks/controls/PageLoader"
import AppAuthProviderContext from "../context"
import { AppAuthProviderProps } from "../hooks/useAppAuthProvider"

const AppAuthProviderView: React.FC<AppAuthProviderProps> = ({ children, contextProps, isBusy }) => {
    if (!isBusy) {
        return <AppAuthProviderContext.Provider value={contextProps}>{children}</AppAuthProviderContext.Provider>
    }
    return <PageLoader />
}
export default AppAuthProviderView
